import { parse } from 'date-fns';

function formatDateLabel( fechaInput: string | Date | number ) {
  const hoy = new Date();
  hoy.setHours( 0, 0, 0, 0 ); // Normaliza a medianoche

  const fecha = new Date( fechaInput );
  fecha.setHours( 0, 0, 0, 0 );

  const msPorDia = 1000 * 60 * 60 * 24;
  const diferencia = Math.round( ( fecha.getTime() - hoy.getTime() ) / msPorDia );

  if ( diferencia < 0 ) return '';
  if ( diferencia === 0 ) return 'Hoy';
  return `En ${diferencia} día${diferencia === 1 ? '' : 's'}`;
}

function mergeDateAndTimeUTC( dateStr:string, timeStr:string ) {
  const [day, month, year] = dateStr.split( '/' );
  const isoDate = `${year}-${month.padStart( 2, '0' )}-${day.padStart( 2, '0' )}`;
  const localDate = new Date( `${isoDate}T${timeStr}` );

  return localDate.toISOString();
}

function mergeDateAndTime( dateStr:string, timeStr:string ) {
  const [day, month, year] = dateStr.split( '/' );
  const isoDate = `${year}-${month.padStart( 2, '0' )}-${day.padStart( 2, '0' )}`;
  return `${isoDate}T${timeStr}Z`;
}

function formatToDate( dateStr:string ) {
  return parse( dateStr, 'dd/MM/yyyy', new Date() );
}

function allDayEnd( dateStr: string ) {
  const [day, month, year] = dateStr.split( '/' );
  const y = Number( year );
  const m = Number( month ) - 1; // mes 0-based
  const d = Number( day );

  const startLocal = new Date( y, m, d, 0, 0, 0, 0 );
  const endLocal = new Date( startLocal );
  endLocal.setDate( endLocal.getDate() + 1 );

  const pad = ( n: number ) => String( n ).padStart( 2, '0' );
  const yyyy = endLocal.getFullYear();
  const MM = pad( endLocal.getMonth() + 1 );
  const DD = pad( endLocal.getDate() );
  return `${yyyy}-${MM}-${DD}T00:00:00Z`;
}

function isValidDate( value: unknown ): value is Date {
  if ( value instanceof Date ) {
    return !Number.isNaN( value.getTime() );
  }

  if ( typeof value === 'string' || typeof value === 'number' ) {
    const date = new Date( value );
    return !Number.isNaN( date.getTime() );
  }

  return false;
}

const isValidDateValidator = ( value?: string ) => {
  if ( !value ) return true;
  if ( value.includes( '_' ) ) return false;

  const [day, month, year] = value.split( '/' ).map( Number );
  if ( !day || !month || !year ) return false;

  const date = new Date( year, month - 1, day );

  return (
    date.getFullYear() === year
        && date.getMonth() === month - 1
        && date.getDate() === day
  );
};

export {
  formatDateLabel,
  mergeDateAndTime,
  mergeDateAndTimeUTC,
  allDayEnd,
  isValidDate,
  isValidDateValidator,
  formatToDate,
};
